<template>
<div style="margin: 0 30px">
  <el-form style="margin-right: 30px" :model="addEditEconForm" :rules="addEditEconRules" ref="addEditEconForm" label-width="120px" class="demo-ruleForm">
    <el-form-item label="退休前工作单位" prop="">
      <el-input v-model="addEditEconForm.retireUnit" placeholder="请输入退休前工作单位"></el-input>
    </el-form-item>
    <el-form-item label="社保号" prop="">
      <el-input v-model="addEditEconForm.social_security_number" placeholder="请输入社保号"></el-input>
    </el-form-item>
    <el-form-item label="经济来源" prop="">
      <el-select v-fixZoom v-model="addEditEconForm.economicSource" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in economicArr" :key="item.value" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="养老保障情况" prop="">
      <el-select v-fixZoom v-model="addEditEconForm.annuityGuarantee" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in annuityArr" :key="item.value" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="医疗保障情况" prop="">
      <el-select v-fixZoom v-model="addEditEconForm.medicalGuarantee" filterable placeholder="请选择" style="width: 100%">
        <el-option v-for="item in medicalArr" :key="item.value" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="月收入情况" prop="">
      <el-input v-model="addEditEconForm.income" placeholder="请输入月收入情况"></el-input>
    </el-form-item>
  </el-form>
  <div style="height: 50px">
    <el-row style="margin: 0 20px">
      <el-col :span="12">
        <div class="cancel-btn" @click="closeAddEdit()">
          <span>取消</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="send-btn" @click="submitAddEditUnit('addEditEconForm')">
          <span>确定</span>
        </div>
      </el-col>
    </el-row>
  </div>
</div>
</template>

<script>
import {updateelderly} from '../../../api/yanglaoyuan'

export default {
  name: 'economicSituation',
  props: {
    economicObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isJuJia: false,
      oldPersonRow: '',
      entityelderlyservice: '',
      economicArr: [],
      annuityArr: [],
      medicalArr: [],
      addEditEconForm: {
        id: '',
        social_security_number: '',
        extra_info: {},
        // 经济情况
        // social_security_number: '',
        retireUnit: '',
        economicSource: '',
        annuityGuarantee: '',
        medicalGuarantee: '',
        income: ''
      },
      addEditEconRules: {
        name: [
          {required: true, message: '请输入', trigger: 'blur'}
        ]
      }
    }
  },
  created () {
    this.economicArr = this.commonType.getEconomicArr()
    this.annuityArr = this.commonType.getAnnuityGuaranteeArr()
    this.medicalArr = this.commonType.getMedicalGuaranteeArr()
    this.entityelderlyservice = this.economicObj.entityelderlyservice
    this.oldPersonRow = this.economicObj.oldPersonRow
    console.log(1111, this.economicObj.isJuJia)
    this.isJuJia = this.economicObj.isJuJia
    this.getStartEconomic()
  },
  methods: {
    getStartEconomic () {
      if (this.oldPersonRow === '' || this.oldPersonRow.id === 0) {
        this.$message({
          message: '请先新增老人基本信息。',
          type: 'warning'
        })
        return
      }
      let info = null
      if (this.oldPersonRow.extra_info && this.oldPersonRow.extra_info !== '') {
        info = JSON.parse(this.oldPersonRow.extra_info)
      }
      this.addEditEconForm = this.commonType.getOldPersonForm(this.oldPersonRow, info)
      console.log(3, this.addEditEconForm)
    },
    closeAddEdit () {
      this.$emit('changeEndEconomic', {type: 'close'})
    },
    submitAddEditUnit (formName) {
      let vm = this
      console.log(this.isJuJia)
      console.log(vm.isJuJia)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = vm.commonType.getJsonInfo(vm.addEditEconForm)
          if (vm.isJuJia) {
            vm.$emit('changeEndEconomic', data.extra_info)
          } else {
            updateelderly(data).then(res => {
              let obj = {
                type: 'isBtnEconomic',
                addEditEconForm: this.addEditEconForm,
                extra_info: data.extra_info
              }
              vm.$emit('changeEndEconomic', obj)
              vm.$notify({title: '成功', message: '成功编辑经济情况', type: 'success', duration: 2000})
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/economicSituation.vue